<template>
  <div class="table-widget">
    <div class="row text-center">
      <div class="col-md" v-for="day in ld.get(appdata.response, 'kp:3day', [])" :key="day[0].date">
        <h3>{{ DateTime.fromISO(ld.get(day, '0.date', DateTime.fromISO('1970-01-01 00:00:00'))).toFormat('DD') }}</h3>
        <div :class="'row ' + (hour.current ? 'highlight' : '')" v-for="hour in day" :key="hour.date">
          <h4 class="col-9">{{ DateTime.fromISO(hour.date).toFormat('T') }}-{{ DateTime.fromISO(hour.date).plus({ hours: 3 }).toFormat('T') }}</h4>
          <h4 class="col-3" :style="'color: ' + hour.color + ';'">{{ hour.value }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { get } from 'lodash'
import { DateTime } from 'luxon'

export default {

  name: 'Kp3Day',
  props: ["appdata", "options"],

  data() {
    return {
      vals: [],
      ld: {
        get: _.get
      },
      DateTime: DateTime
    }
  }
}
</script>

<style scoped>
  .highlight {
    background-color: rgba(255, 255, 255, 0.15);
  }
</style>
